var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightLiquidMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 0.859,
    y1: 19.153,
    x2: 0.859,
    y2: 10.13
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 11.79,11.51 19.16,11.51 19.16,17.78 11.77,17.78  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 8.23,17.78 0.86,17.78 0.86,11.51 8.21,11.51  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 19.162,
    y1: 19.153,
    x2: 19.162,
    y2: 10.13
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 10,
    cy: 14.642,
    r: 3.609
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    d: "M10.209,0.867c-0.08-0.118-0.277-0.118-0.357,0 C9.749,1.019,7.336,4.599,7.336,6.017c0,1.485,1.209,2.694,2.694,2.694c1.485,0,2.694-1.209,2.694-2.694 C12.725,4.599,10.311,1.019,10.209,0.867z M10.03,8.281c-1.248,0-2.263-1.015-2.263-2.263c0-0.984,1.497-3.471,2.263-4.641 c0.766,1.169,2.263,3.655,2.263,4.641C12.293,7.266,11.278,8.281,10.03,8.281z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLiquidMeter);
export default __webpack_public_path__ + "static/media/light-liquid-meter.9a7b5b1d4d301244fc63c464d2ce845f.svg";
export { ForwardRef as ReactComponent };